"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoggedInClientUser = useLoggedInClientUser;
var react_redux_1 = require("react-redux");
var client_1 = require("../api/client");
// The session user and the client user record are separate: the record carries the branches a manager
// owns, so it has to be looked up by user_id. Every caller asks with the same argument, so they share
// one cache entry rather than depending on another page having loaded the list first.
function useLoggedInClientUser() {
    var _a;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, client_1.useGetClientUsersQuery)({ page: 1, size: 200 }, { skip: !(user === null || user === void 0 ? void 0 : user._id) }), data = _b.data, isLoading = _b.isLoading;
    var loggedInClientUser = ((_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : []).find(function (clientUser) { return clientUser.user_id === (user === null || user === void 0 ? void 0 : user._id); });
    return { loggedInClientUser: loggedInClientUser, isLoading: isLoading };
}
